/**
 * Canonical display locale for numbers, currency, and Angular’s `LOCALE_ID`.
 * The host app should provide `{ provide: LOCALE_ID, useValue: MOTES_DISPLAY_LOCALE_ID }`.
 * Templates can omit the last `: locale` argument on `number` / `currency` / `percent` pipes
 * so they inherit this value.
 */
export const MOTES_DISPLAY_LOCALE_ID = 'en-US' as const;
